/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillEfficacyGetSettings } from "../funcs/skillEfficacyGetSettings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SkillEfficacySettings } from "../models/components/skillefficacysettings.js";
import {
  GetSkillEfficacySettingsRequest,
  GetSkillEfficacySettingsSecurity,
} from "../models/operations/getskillefficacysettings.js";
import { unwrapAsync } from "../types/fp.js";
export type SkillEfficacySettingsQueryData = SkillEfficacySettings;

export function prefetchSkillEfficacySettings(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetSkillEfficacySettingsRequest | undefined,
  security?: GetSkillEfficacySettingsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillEfficacySettingsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSkillEfficacySettingsQuery(
  client$: GramCore,
  request?: GetSkillEfficacySettingsRequest | undefined,
  security?: GetSkillEfficacySettingsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SkillEfficacySettingsQueryData>;
} {
  return {
    queryKey: queryKeySkillEfficacySettings({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function skillEfficacySettingsQueryFn(
      ctx,
    ): Promise<SkillEfficacySettingsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillEfficacyGetSettings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySkillEfficacySettings(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skillEfficacy", "getSettings", parameters];
}
